import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
  selector: '[appTwoDigitDecimaNumber]',
})
export class TwoDigitDecimaNumberDirective {
  @Input() appTwoDecimal: boolean = true;


  @Input() set appConditionalHighlight(condition: boolean) {
    this.appTwoDecimal = condition;
  }
  private regex: RegExp = /^\d+(\.\d{0,2})?$/; // Regex for numbers with up to two decimal places
  constructor(private el: ElementRef) {}
  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    if (!this.appTwoDecimal) {
      return;
    }
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;
    if (inputValue === '' || inputValue === '-') {
      return;
    }
    if (!this.regex.test(inputValue)) {
      const truncatedValue = inputValue.slice(0, -1);
      inputElement.value = truncatedValue;
    }
  }
}
